import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-teal-600 last:border-b-0" data-id="element-108">
      <button className="flex justify-between items-center w-full py-4 px-2 text-left font-medium focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-109">
        <span className="text-lg" data-id="element-110">{question}</span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 flex-shrink-0" data-id="element-111" /> : <ChevronDownIcon className="w-5 h-5 flex-shrink-0" data-id="element-112" />}
      </button>
      {isOpen && <div className="pb-4 px-2" data-id="element-113">
          <p className="text-teal-100" data-id="element-114">{answer}</p>
        </div>}
    </div>;
};
export const FAQSection = () => {
  const faqs = [{
    question: 'Is this a replacement for therapy or medical care?',
    answer: "No. Neurotoned is not a replacement for therapy, medication, or medical care. It's a therapist-designed support tool that helps you gently regulate your nervous system using body-based methods. Always consult your healthcare provider for personalized advice."
  }, {
    question: "I've already tried somatic tools. How is this different?",
    answer: "Neurotoned offers a structured daily progression, designed by licensed trauma professionals. It's not random Instagram tips—it's a full framework that builds week by week, helping you shift from dysregulation to deep resilience."
  }, {
    question: 'What happens after I buy the program?',
    answer: "You'll get immediate access to all 30 days of the program, including daily video practices and bonus lessons. You can go at your own pace. Many participants start seeing changes in the first few days."
  }, {
    question: 'Do I have to follow the program exactly every day?',
    answer: "Not at all. You're encouraged to move at your own pace. Some participants do it daily, others take more time. The key is consistency and tuning in to what feels right for your body."
  }, {
    question: 'Will I have access to the content forever?',
    answer: 'Yes! This is a one-time payment for lifetime access. You can revisit the practices any time you need a reset.'
  }, {
    question: "What if I don't feel any changes?",
    answer: "That's why we offer a 30-day money-back guarantee. If you complete the program and don't feel a shift in your nervous system, just email us for a full refund—no pressure, no hoops."
  }, {
    question: "Is this safe if I've experienced severe trauma?",
    answer: 'Yes. The program is built to be trauma-informed and body-safe. All practices are designed to be gentle, grounding, and non-triggering. You never have to talk about or relive your trauma.'
  }, {
    question: 'Is this program suitable for people with chronic illness, fatigue, or neurodivergence?',
    answer: 'Absolutely. Many of our members come with nervous system sensitivity, chronic pain, fatigue, or neurodivergent traits. The program is intentionally slow, accessible, and customizable to your capacity.'
  }, {
    question: 'Can I access this on my phone or tablet?',
    answer: 'Yes. Neurotoned is fully mobile-friendly. You can use it on your phone, tablet, or desktop with no app needed.'
  }];
  return <section className="bg-gradient-to-b from-teal-700 to-teal-800 text-white py-16" data-id="element-115">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-117">
          Frequently Asked Questions
        </h2>
        <div className="bg-teal-800/50 rounded-lg p-6 shadow-lg mb-10" data-id="element-118">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-119" />)}
        </div>
      </div>
    </section>;
};